import React, { useEffect, useState } from "react";
import { Modal, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ProductZoom from "../../components/ProductZoom";
import {
  useBlockPropertyMutation,
  useLazyFoodPackageRemoveQuery,
  useLazyPropertyServiceQuery,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import CloseIcon from "@mui/icons-material/Close";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import AddIcon from "@mui/icons-material/Add";
import { editIcon } from "../../assets/img";
import BorderColorIcon from "@mui/icons-material/BorderColor";

const DayOuting = ({ list }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [modal, setModal] = useState(false);
  const [details, setDetails] = useState({});
  const [amenities, setamenities] = useState([]);
  const [food_packages, setfood_packages] = useState([]);

  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());

  // RTK QUERY
  const [blockPropertyApi] = useBlockPropertyMutation();
  const [propertyServiceApi] = useLazyPropertyServiceQuery();
  const [foodRemoveApi] = useLazyFoodPackageRemoveQuery();

  const [full_from_date, setfull_from_date] = useState("");
  const [full_to_date, setfull_to_date] = useState("");

  const [full_from_dateErr, setfull_from_dateErr] = useState(false);
  const [full_to_dateErr, setfull_to_dateErr] = useState(false);
  const [btn, setBtn] = useState(false);

  const blockProperty = () => {
    if (full_from_date?.length == 0 || full_to_date?.length == 0) {
      setfull_from_dateErr(true);
      setfull_to_dateErr(true);
    } else {
      let formdata = new FormData();
      formdata.append("from_date", moment(full_from_date).format("YYYY-MM-DD"));
      formdata.append("to_date", moment(full_to_date).format("YYYY-MM-DD"));
      formdata.append("property_id", location?.state?.data?.id);
      setBtn(true);
      dispatch(saveLoader(true));
      blockPropertyApi(formdata)
        .unwrap()
        .then((res) => {
          setBtn(false);
          dispatch(saveLoader(false));
          if (res?.status == "success") {
            onClose(false);
            Swal.fire({
              text: res?.message,
              icon: "success",
            });
            getView();
          }
        })
        .catch((err) => {
          console.log("err", err);
          setBtn(false);
          dispatch(saveLoader(false));
        });
    }
  };

  const onClose = () => {
    setfull_from_date("");
    setfull_to_date("");
    setfull_from_dateErr(false);
    setfull_to_dateErr(false);
    setModal(false);
  };

  // DAYOUT VIEW
  const getView = () => {
    propertyServiceApi({ id: location?.state?.data?.id, type: "day_outing" })
      .unwrap()
      .then((res) => {
        setDetails(res?.day_outing);
        setfood_packages(res?.food_packages);
        setamenities(res?.amenities);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
    minMaxDate();
  }, []);

  const minMaxDate = () => {
    var someDate = new Date();

    // min date
    someDate.setDate(someDate.getDate() + 2); //number  of days to add, e.x. 15 days
    var dateFormated = someDate.toISOString().substr(0, 10);
    setMinDate(dateFormated);

    // max date
    someDate.setDate(someDate.getDate() + 12); //number  of days to add, e.x. 15 days
    var dateFormateds = someDate.toISOString().substr(0, 10);
    setMaxDate(dateFormateds);
  };

  // DELETE FOOD
  const deleteFood = (id) => {
    dispatch(saveLoader(true));
    setBtn(true);
    foodRemoveApi(id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setBtn(false);
        if (res?.status == "success" || res?.data?.status == "success") {
          getView();
          Swal.fire({
            text: res?.message,
            icon: "success",
          });
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        setBtn(false);
        console.log("err", err);
      });
  };

  return (
    <div>
      {details?.id ? (
        <Row>
          <div className="col-md-12 d-flex">
            <div className="col-md-6">
              <div className="block-header add-btn-new">
                <button onClick={() => setModal(true)}>Day Outing Block</button>
              </div>
            </div>
            <div className="col-md-6 text-end">
              <div className="block-header add-btn-new">
                <button
                  onClick={() =>
                    navigate("/food-package", { state: location?.state })
                  }
                >
                  <AddIcon />
                  Add Food Packages
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-12 text-end ">
            <div className="block-header add-btn-new">
              <button
                className=""
                onClick={() =>
                  navigate("/team-outing", {
                    state: {
                      type: location?.state?.type,
                      data: location?.state?.data,
                      item: location?.state?.data,
                      itemType: "edit",
                    },
                  })
                }
              >
                <BorderColorIcon fontSize="20" className="mx-1 mb-1" />
                Edit
              </button>
            </div>
          </div>
        </Row>
      ) : (
        <div className="col-md-12 mb-5 text-end">
          <div className="block-header add-btn-new">
            <button
              onClick={() =>
                navigate("/team-outing", { state: location?.state })
              }
            >
              <AddIcon />
              Add Details
            </button>
          </div>
        </div>
      )}
      {details?.id && (
        <div>
          <div className="user-detail-table">
            <table className="tabledetails table-borderless user-det w-100 mb-5">
              <thead>
                <th colspan="3" className="h8 mb-0 font-weight-light p-3">
                  Team Outing Details
                </th>
              </thead>
              {details?.serviceprice?.id && (
                <tbody>
                  <tr>
                    <td style={{ width: "40%" }}>Admin Commision</td>
                    <td>:</td>
                    <td>{details?.serviceprice?.admin_commission}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Adult Price</td>
                    <td>:</td>
                    <td>
                      {details?.serviceprice?.adult_price
                        ? "₹" + details?.serviceprice?.adult_price
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Child Price</td>
                    <td>:</td>
                    <td>{details?.serviceprice?.child_price}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Minimum Persons</td>
                    <td>:</td>

                    <td>{details?.serviceprice?.min_persons}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Maximum Persons</td>
                    <td>:</td>
                    <td>{details?.serviceprice?.max_persons}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Minimum Childrens</td>
                    <td>:</td>
                    <td>{details?.serviceprice?.min_childrens}</td>
                  </tr>

                  <tr>
                    <td style={{ width: "40%" }}>Maximum Childrens</td>
                    <td>:</td>
                    <td>{details?.serviceprice?.max_childrens}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Weekend Days</td>
                    <td>:</td>
                    <td>{details?.weekend_days}</td>
                  </tr>
                  <tr className="foods-det">
                    <td style={{ width: "40%" }}>Weekend Percentage</td>
                    <td>:</td>
                    <td>{details?.weekend_percentage}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Amenities</td>
                    <td>:</td>
                    <td className="amenity-type">
                      <ul>
                        {amenities?.map((item, ind) => {
                          return (
                            <li key={ind}>
                              <img src={item?.image} />
                              {item?.name}
                            </li>
                          );
                        })}
                      </ul>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
          {food_packages?.map((item, ind) => {
            return (
              <div className="user-detail-table" key={ind}>
                <table className="tabledetails table-borderless user-det w-100 mb-5">
                  <thead>
                    <th colspan="3" className="h8 mb-0 font-weight-light p-3">
                      <div className="d-flex ac-jb">
                        <p>Package {ind + 1}</p>
                        <div className="d-flex gap-2">
                          <button
                            className="badge-primary btn"
                            style={{ width: "4.5rem" }}
                            onClick={() =>
                              navigate("/food-package", {
                                state: {
                                  type: location?.state?.type,
                                  data: location?.state?.data,
                                  item: item,
                                  itemType: "edit",
                                },
                              })
                            }
                          >
                            Edit
                          </button>
                          <button
                            className={`btn-secondary btn ${
                              btn ? "opacity-50" : ""
                            }`}
                            style={{ padding: "0.4rem" }}
                            onClick={() => deleteFood(item?.id)}
                            disabled={btn}
                          >
                            <CloseIcon />
                          </button>
                        </div>
                      </div>
                    </th>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ width: "40%" }}>Package Name</td>
                      <td>:</td>
                      <td>{item?.package_name}</td>
                    </tr>
                    <tr>
                      <td style={{ width: "40%" }}>Description</td>
                      <td>:</td>
                      <td>{item?.short_text}</td>
                    </tr>
                    <tr>
                      <td style={{ width: "40%" }}>Price Per Person</td>
                      <td>:</td>
                      <td>{item?.price_per_person}</td>
                    </tr>
                    <tr>
                      <td style={{ width: "40%" }}>Food Menus</td>
                      <td>:</td>

                      <td class="row">
                        {item?.menuitems?.map((menu, mind) => {
                          return (
                            <div class="col-md-4 mt-2">
                              {menu?.menu} - {menu?.menu_item}
                            </div>
                          );
                        })}
                        <br />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            );
          })}
        </div>
      )}

      <Modal
        show={modal}
        onHide={() => {
          setModal(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <div className="p-3">
          <Row>
            <div className="d-flex ac-jb">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20">
                Day Outing Block
              </label>
              <button className="cust-btn" onClick={() => onClose(false)}>
                <CloseIcon />
              </button>
            </div>
          </Row>
          <Row className="mt-4">
            <div className="col-md-12 mb-4">
              <label className="f1 fs-sm-12 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-2 col-md-12">
                Select Date
              </label>
              <div className="full-date-pick">
                <DatePicker
                  selected={full_from_date}
                  onChange={(date) => {
                    setfull_from_date(date);
                  }}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  dateFormat="yyyy-MM-dd"
                  todayButton="Today"
                  className="form-control custom-select"
                  placeholderText="YYYY-MM-DD"
                  minDate={minDate}
                  maxDate={maxDate}
                />
              </div>
              {full_from_date?.length == 0 && full_from_dateErr && (
                <p className="err">Select Date</p>
              )}
            </div>
          </Row>
          <Row className="mt-4 d-flex ac-jc">
            <div className="col-md-2 text-center">
              <button
                className={`submit-btn ${btn ? "opacity-50" : ""}`}
                onClick={() => blockProperty()}
                disabled={btn}
              >
                OK
              </button>
            </div>
          </Row>
        </div>
      </Modal>
    </div>
  );
};

export default DayOuting;
